import * as React from 'react'
import classnames from 'classnames'

import cls from './content.module.scss'

const UikContentItem = ({ className, children, Component, ...rest }: UikContentItemProps) => (
  <Component className={classnames(cls.item, className)} {...rest}>
    {children}
  </Component>
)

UikContentItem.defaultProps = {
  className: null,
  Component: 'div',
  children: null,
}

export default UikContentItem
